/* istanbul ignore next */
const ACTIONS = {
    FETCH_PAGE1_DATA_SUCCESS: 'FETCH_PAGE1_DATA_SUCCESS',
    FETCH_PAGE1_DATA_ERROR: 'FETCH_PAGE1_DATA_ERROR',

    SUBMIT_REQUEST_ACCESS: 'SUBMIT_REQUEST_ACCESS',
    REQUEST_ACCESS_SUCCESS: 'REQUEST_ACCESS_SUCCESS',
    REQUEST_ACCESS_FAILURE: 'REQUEST_ACCESS_FAILURE',

    TRIGGER_EDAP_PAGEVIEW: 'TRIGGER_EDAP_PAGEVIEW',
    TRIGGER_EDAP_EVENT: 'TRIGGER_EDAP_EVENT',

    ENABLE_LOAD_OVERLAY: 'ENABLE_LOAD_OVERLAY',
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    enableLoadOverlay(loading) {
        return {
            type: ACTIONS.ENABLE_LOAD_OVERLAY,
            payload: {
                loading,
            },
        };
    },

    fetchPage1DataSuccess(response) {
        return {
            type: ACTIONS.FETCH_PAGE1_DATA_SUCCESS,
            payload: {
                response,
            },
        };
    },

    fetchPage1DataError(response) {
        return {
            type: ACTIONS.FETCH_PAGE1_DATA_ERROR,
            payload: {
                response,
            },
        };
    },

    triggerEdapPageView() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PAGEVIEW,
        };
    },

    triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName,
                eventData,
                options,
            },
        };
    },

    submitRequestAccess(payload) {
        return {
            type: ACTIONS.SUBMIT_REQUEST_ACCESS,
            payload,
        };
    },

    requestAccessSucess() {
        return {
            type: ACTIONS.REQUEST_ACCESS_SUCCESS,
        };
    },

    requestAccessFailure(errorKey) {
        return {
            type: ACTIONS.REQUEST_ACCESS_FAILURE,
            payload: {
                errorKey,
            },
        };
    },

    postNameError() {
        return {
            type: ACTIONS.POST_NAME_ERROR,
        };
    },
};
export default {...ACTIONS, ...ACTION_CREATORS};
